import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import {
  CRUDUserResponse,
  GetTokenResponse,
  GetUserAllList,
  GetUserDetailResponse,
  GetUserProfileResponse,
  RequestTemporaryBody,
  RequestTemporaryResponse,
  ResponseUserInfo,
  updateProfileIamgeResponse,
  UserDetail,
  UserInfo,
} from "./interfaces/userInterface.interface";
import qs from "qs";
import {
  CreateUserRequest,
  GetUserListResposne,
  GetUserRequest,
} from "api/interfaces/userInterface.interface";
import {
  CommonResponse,
  CustomError,
} from "./interfaces/commonInterface.interface";
import {
  CUDAccountResponse,
  getAccuntOwnersReponse,
} from "./interfaces/accountInterface.interface";
import { setAxiosHeaders } from "utils/AuthUtil";
const USER_API_PATH = "/user";

export const getUserProfile = async ({
  accountId,
  userId,
}: {
  accountId: string;
  userId: string;
}): Promise<GetUserDetailResponse> => {
  try {
    const { data }: AxiosResponse<GetUserDetailResponse> =
      await AxiosInstance.get(
        `${USER_API_PATH}/get/profile/${accountId}/${userId}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const putChangeProfile = async ({
  userId,
  type,
  payload,
}: {
  userId: string;
  type: string;
  payload: any;
}): Promise<GetUserProfileResponse> => {
  try {
    const { data }: AxiosResponse<GetUserProfileResponse> =
      await AxiosInstance.put(
        `${USER_API_PATH}/change/${type}/${userId}`,
        payload
      );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getTokenInfo = async (
  token: string
): Promise<GetTokenResponse> => {
  try {
    const res: AxiosResponse<GetTokenResponse> = await AxiosInstance.get(
      `${USER_API_PATH}/token?token=${token}`
    );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getAccountOwners = async (
  accountId: string
): Promise<getAccuntOwnersReponse> => {
  try {
    const { data }: AxiosResponse<getAccuntOwnersReponse> =
      await AxiosInstance.get(`${USER_API_PATH}/get/owner/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getUserDetail = async (): Promise<UserInfo> => {
  try {
    setAxiosHeaders({
      roleId: localStorage.getItem("r-mem") as string,
    });
    const res: AxiosResponse<ResponseUserInfo> = await AxiosInstance.get(
      `${USER_API_PATH}/get/detail`
    );
    return res.data.result;
  } catch (e) {
    const customErr = e as CustomError;
    //유저권한이 없는 경우 retry로 재조회
    if (customErr?.response?.data?.error === 1005) {
      return getNotPermissioUserDetail();
    }
    throw customErr;
  } finally {
    setAxiosHeaders()
  }
};

export const getNotPermissioUserDetail = async (): Promise<UserInfo> => {
  try {
    setAxiosHeaders({
      roleId: localStorage.getItem("r-mem") as string,
    });
    const res: AxiosResponse<ResponseUserInfo> = await AxiosInstance.get(
      `${USER_API_PATH}/get/detail/retry`
    );
    return res.data.result;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  } finally {
    setAxiosHeaders()
  }
};

export const getUserDetailAccount = async (
  accountId: string
): Promise<UserInfo> => {
  try {
    setAxiosHeaders({
      roleId: localStorage.getItem("r-mem") as string,
    });
    const res: AxiosResponse<ResponseUserInfo> = await AxiosInstance.get(
      `${USER_API_PATH}/get/detail/${accountId}`
    );
    return res.data.result;
  } catch (e) {
    const customErr = e as CustomError;
    //유저권한이 없는 경우 retry로 재조회
    if (customErr?.response?.data?.error === 1005) {
      return getNotPermissioUserDetailAccount(accountId);
    }
    throw customErr;
  } finally {
    setAxiosHeaders()
  }
};

export const getNotPermissioUserDetailAccount = async (
  accountId: string
): Promise<UserInfo> => {
  try {
    setAxiosHeaders({
      roleId: localStorage.getItem("r-mem") as string,
    });
    const res: AxiosResponse<ResponseUserInfo> = await AxiosInstance.get(
      `${USER_API_PATH}/get/detail/retry/${accountId}`
    );
    return res.data.result;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  } finally {
    setAxiosHeaders()
  }
};

export const getSwitchAccount = async (
  accountId: string
): Promise<UserInfo> => {
  try {
    const res: AxiosResponse<ResponseUserInfo> = await AxiosInstance.get(
      `${USER_API_PATH}/switchAccount/${accountId}`
    );
    return res.data?.result;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getUserList = async ({
  payload,
  accountId,
}: {
  payload: GetUserRequest;
  accountId: string;
}): Promise<GetUserListResposne> => {
  try {
    const res: AxiosResponse<GetUserListResposne> = await AxiosInstance.get(
      `${USER_API_PATH}/list/${accountId}?${qs.stringify(payload)}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getUserTotalList = async ({
  payload,
  accountId,
}: {
  payload: GetUserRequest;
  accountId: string;
}): Promise<GetUserListResposne> => {
  try {
    const res: AxiosResponse<GetUserListResposne> = await AxiosInstance.get(
      `${USER_API_PATH}/totalList/${accountId}?${qs.stringify(payload)}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getUserPrevilegeList = async ({
  accountId,
  previlege,
  payload,
}: {
  accountId: string;
  previlege: string;
  payload: GetUserRequest;
}): Promise<GetUserListResposne> => {
  try {
    const res: AxiosResponse<GetUserListResposne> = await AxiosInstance.get(
      `${USER_API_PATH}/totalListPermUser/${previlege}/${accountId}?${qs.stringify(
        payload
      )}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getUserAllList = async ({
  accountId,
}: {
  accountId: string;
}): Promise<GetUserAllList> => {
  try {
    const res: AxiosResponse<GetUserAllList> = await AxiosInstance.get(
      `${USER_API_PATH}/list/all/active`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const createUser = async ({
  payload,
  accountId,
}: {
  payload: CreateUserRequest;
  accountId: string;
}): Promise<CRUDUserResponse> => {
  try {
    const { data }: AxiosResponse<CRUDUserResponse> = await AxiosInstance.post(
      `${USER_API_PATH}/create/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postRequestTemporary = async ({
  payload,
  accountId,
}: {
  payload: RequestTemporaryBody;
  accountId: string;
}): Promise<RequestTemporaryResponse> => {
  try {
    const { data }: AxiosResponse<RequestTemporaryResponse> =
      await AxiosInstance.post(
        `${USER_API_PATH}/req/temporary/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postApproveTemporaryAccess = async (
  token: string
): Promise<CommonResponse> => {
  try {
    const { data }: AxiosResponse<CommonResponse> = await AxiosInstance.post(
      `${USER_API_PATH}/reqApprove/temporary/${token}`
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const updateUser = async ({
  payload,
  accountId,
  userId,
}: {
  payload: CreateUserRequest;
  accountId: string;
  userId: string;
}): Promise<CRUDUserResponse> => {
  try {
    const { data }: AxiosResponse<CRUDUserResponse> = await AxiosInstance.put(
      `${USER_API_PATH}/update/${accountId}/${userId}`,
      payload
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const deletableUser = async ({
  accountId,
  userId,
}: {
  accountId: string;
  userId: string;
}): Promise<GetUserListResposne> => {
  try {
    const res: AxiosResponse<GetUserListResposne> = await AxiosInstance.get(
      `${USER_API_PATH}/deletable/${accountId}/${userId}`
    );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const deleteUser = async ({
  accountId,
  userId,
}: {
  accountId: string;
  userId: string;
}): Promise<CRUDUserResponse> => {
  try {
    const { data }: AxiosResponse<CRUDUserResponse> =
      await AxiosInstance.delete(
        `${USER_API_PATH}/deactivate/${accountId}/${userId}`
      );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const deactiveProfile = async ({
  userId,
}: {
  userId: string;
}): Promise<CRUDUserResponse> => {
  try {
    const { data }: AxiosResponse<CRUDUserResponse> =
      await AxiosInstance.delete(`${USER_API_PATH}/delete/${userId}`);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const putUpdateProfile = async ({
  accountId,
  userId,
  payload,
}: {
  accountId: string;
  userId: string;
  payload: UserDetail;
}): Promise<CRUDUserResponse> => {
  try {
    const { data }: AxiosResponse<CRUDUserResponse> = await AxiosInstance.put(
      `${USER_API_PATH}/update/profile/${accountId}/${userId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

// update profile image
export const updateProfileIamge = async ({
  accountId,
  userId,
  payload,
}: {
  accountId: string;
  userId: string;
  payload: any;
}): Promise<updateProfileIamgeResponse> => {
  // console.log(accountId, userId, payload);
  try {
    const { data }: AxiosResponse<updateProfileIamgeResponse> =
      await AxiosInstance.put(
        `${USER_API_PATH}/update/profileImage/${accountId}/${userId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

// update profile image
export const updateTheme = async ({
  accountId,
  userId,
  payload,
}: {
  accountId: string;
  userId: string;
  payload: { theme: string };
}): Promise<updateProfileIamgeResponse> => {
  // console.log(accountId, userId, payload);
  try {
    const { data }: AxiosResponse<updateProfileIamgeResponse> =
      await AxiosInstance.put(
        `${USER_API_PATH}/update/theme/${accountId}/${userId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const deleteProfileImage = async ({
  accountId,
  userId,
}: {
  accountId: string;
  userId: string;
}): Promise<void> => {
  try {
    await AxiosInstance.delete(
      `${USER_API_PATH}/delete/profileImage/${accountId}/${userId}`
    );
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postInviteOwner = async ({
  accountId,
  email,
}: {
  accountId: string;
  email: string;
}): Promise<CUDAccountResponse> => {
  try {
    const { data }: AxiosResponse<CUDAccountResponse> =
      await AxiosInstance.post(`${USER_API_PATH}/create/owner/${accountId}`, {
        email,
      });
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};
